import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import { useSelector } from 'react-redux'
import { Button, Loading, Picker } from '../../root/components/common'
import { getRoleName } from 'web/src/utils'
import classNames from 'classnames'

const useStyles = makeStyles(theme => ({
    wrapper: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
    },
    header: {
        textAlign: 'center',
        fontSize: 24,
        color: theme.primary,
        fontWeight: 700,
        lineHeight: 'normal',
        marginBottom: 32
    },
    text: {
        fontSize: 16,
        color: theme.primary,
        fontWeight: 400,
        lineHeight: 'normal',
        textAlign: 'center',
        maxWidth: '80%'
    },
    marginBottom: {
        marginBottom: 16
    },
    buttons: {
        display: 'flex',
        gap: 100,
        marginTop: 15
    },
    pickerWrapper: {
        display: 'flex',
        gap: 20,
        alignItems: 'center'
    }
}))

export const ReassignAndConfirmDeleteRoleModal = ({
    isLoading,
    roleId,
    onClose,
    onConfirmDelete
}) => {
    const classes = useStyles()
    const { locale } = useSelector(state => state.main)

    const [reassignRoleId, setReassignRoleId] = useState(roleId)

    const allRoles = useSelector(state =>
        state.userManagement.roles
            ? state.userManagement.roles.reduce((acc, role) => {
                  acc[role.id] = getRoleName(role, locale)
                  return acc
              }, {})
            : null
    )

    const onRoleChange = id => setReassignRoleId(id)

    const onRoleDelete = () => onConfirmDelete(reassignRoleId)

    return (
        <div className={classes.wrapper}>
            {isLoading && <Loading />}
            {!isLoading && (
                <>
                    <div className={classes.header}>
                        {locale.userManagement.reassignAndDeleteModal.header}
                    </div>
                    <div
                        className={classNames(
                            classes.text,
                            classes.marginBottom
                        )}
                    >
                        {locale.userManagement.reassignAndDeleteModal.textOne}
                    </div>
                    <div
                        className={classNames(
                            classes.text,
                            classes.marginBottom
                        )}
                    >
                        {locale.userManagement.reassignAndDeleteModal.textTwo}
                    </div>
                    <div className={classes.pickerWrapper}>
                        <div className={classes.text}>{locale.common.role}</div>
                        <Picker
                            options={allRoles}
                            onChange={onRoleChange}
                            value={reassignRoleId}
                        />
                    </div>
                    <div className={classes.buttons}>
                        <Button reverted onClick={onClose}>
                            {locale.common.cancel}
                        </Button>
                        <Button
                            onClick={onRoleDelete}
                            disabled={roleId === reassignRoleId}
                        >
                            {locale.common.delete}
                        </Button>
                    </div>
                </>
            )}
        </div>
    )
}
